import DateUtils from "../../../shared/utils/DateUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";

export const getHolidayDaysInMonth = (
	month,
	year = new Date().getFullYear()
) => {
	const monthNumber = Number(month);
	const yearNumber = Number(year);

	if (
		!Number.isInteger(monthNumber) ||
		monthNumber < 1 ||
		monthNumber > 12 ||
		!Number.isInteger(yearNumber) ||
		yearNumber < 1
	) {
		return 0;
	}

	const isLeapYear =
		yearNumber % 400 === 0 ||
		(yearNumber % 4 === 0 && yearNumber % 100 !== 0);

	const daysPerMonth = [
		31,
		isLeapYear ? 29 : 28,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	];

	return daysPerMonth[monthNumber - 1];
};

export const formatHolidayResponse = holiday => {
	const date = holiday.data || "";
	const [year, month, day] = date.split("T")[0].split("-");

	return {
		id: holiday.id,
		date: holiday.data,
		name: holiday.nome,
		year,
		month: month ? String(Number(month)) : "",
		day: day ? String(Number(day)) : "",
		isNational: holiday.nacional,
		createdAt: holiday.dataCriacao,
		updatedAt: holiday.dataUltimaAtualizacao,
		dateLabel: DateUtils.formatDateToBrazilian(holiday.data),
		createdAtLabel: DateUtils.formatDateToBrazilian(
			holiday.dataCriacao
		),
		updatedAtLabel: DateUtils.formatDateToBrazilian(
			holiday.dataUltimaAtualizacao
		),
		raw: holiday
	};
};

export const formatHolidayPayload = values => {
	const year = values.year || new Date().getFullYear();
	const day = String(values.day).padStart(2, "0");
	const month = String(values.month).padStart(2, "0");

	return {
		data: DateUtils.formatDateToAmerican(
			`${day}/${month}/${year}`
		),
		nome: values.name
	};
};

export const validateHolidayPayload = values => {
	const errors = {};
	const month = Number(values.month);
	const day = Number(values.day);
	const year = values.year || new Date().getFullYear();

	if (!hasValue(values.name)) {
		errors.name = "Informe o nome do feriado.";
	}

	if (!hasValue(values.month)) {
		errors.month = "Informe o mês do feriado.";
	} else if (
		!Number.isInteger(month) ||
		month < 1 ||
		month > 12
	) {
		errors.month = "Informe um mês válido.";
	}

	if (!hasValue(values.day)) {
		errors.day = "Informe o dia do feriado.";
	} else if (!errors.month) {
		const totalDays = getHolidayDaysInMonth(month, year);

		if (
			!Number.isInteger(day) ||
			day < 1 ||
			day > totalDays
		) {
			errors.day = "Informe um dia válido para o mês e ano.";
		}
	}

	return errors;
};